import { useState as a, useEffect as i, useCallback as u } from "react";
const f = () => {
  const [t, n] = a(0);
  i(() => {
    if (t <= 0)
      return;
    let e = Date.now();
    const r = setInterval(() => {
      const o = t - (Date.now() - e) / 1e3;
      if (o > 0) {
        n(Math.ceil(o)), e = Date.now();
        return;
      }
      n(0);
    }, 1e3);
    return () => {
      r && clearInterval(r);
    };
  }, [t]);
  const s = u((e) => {
    n(e);
  }, []);
  return [t, s];
};
export {
  f as useCountDownTimer
};
//# sourceMappingURL=useCountdownTimer.js.map
